import React from "react";
import {Close, LinkSharp, WhatsApp} from "@material-ui/icons";
import {Instagram, Phone, PhoneCall, Share2} from "react-feather";
import {Col, NavLink, Row} from "reactstrap";
import logo from "../../../assets/img/logo/logo1.webp";
import {FaInstagram} from "react-icons/fa";
import {FaTelegramPlane} from "react-icons/fa";
import Technical from "../../../assets/img/logo/Technical professional.png";
import {FiPhoneCall, FiYoutube} from "react-icons/fi";
import {MdOutlineWhatsapp} from "react-icons/md";
import zarin from "../../../assets/img/elements/zarin.png"
import data from "../../../assets/data/configs/storeConfig.json"
import {connect} from "react-redux";
import RenderMedia from "../../media/renderMedia";
import {Link} from "react-router-dom";
import {history} from "../../../history";
import {BiSupport} from "react-icons/bi";


class Footer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            whatsapp: false,
            enamad: true,
            quick_access: this.props.UI.menu ? this.props.UI.menu : [],
            courses: this.props.UI.courses ? this.props.UI.courses : [],
            tags: this.props.UI.tags ? this.props.UI.tags : [],
            settings: this.props.UI.settings ? this.props.UI.settings : [],
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((this.props.UI !== prevProps.UI)) {
            this.setState({
                quick_access: this.props.UI.menu ? this.props.UI.menu : [],
                courses: this.props.UI.courses ? this.props.UI.courses : [],
                tags: this.props.UI.tags ? this.props.UI.tags : [],
                settings: this.props.UI.settings ? this.props.UI.settings : [],
            })
        }
    }

    support = () => {
        this.setState({
            whatsapp: !this.state.whatsapp,
        })
    }
    handleSupport = (targetPath) => {
        if (targetPath) history.push(targetPath)
        this.setState({
            support: !this.state.support,
        })
    }

    render() {
        return (
            <>
                <div className="web-footer">
                    <div className='web-footer-top m-auto rounded d-flex align-items-center justify-content-around p-4'>
                        <div>
                            <span className='h2 text-white'>جهت کسب اطلاعات بیشتر با ما در تماس باشید.</span>
                        </div>
                        <div>
                            <a href={`tel:${data.mobile[0]}`}>
                                <button className="btn">
                                    <FiPhoneCall/>
                                    {data.mobile[0]}
                                </button>
                            </a>
                        </div>
                    </div>
                    <div className="bg-black-footer ">
                        <Row>
                            <Col md={4} sm={12}>
                                <div className='footer-logo'>

                                    <h5>{data.footerName}</h5>
                                </div>
                                <div className='footer-desc'>
                                    <p dangerouslySetInnerHTML={{__html:this.state?.settings?.short_about_us}}/>
                                </div>
                                <div className='footer-social'>
                                    {
                                        <RenderMedia/>
                                    }
                                </div>
                            </Col>
                            <Col md={8} sm={12}>
                                <Row>
                                    <Col md={3} sm={12}>
                                        <h5 className='title-footer'>لینک دسترسی سریع</h5>
                                        <div className='footer-speed-container'>
                                            {
                                                this.state.quick_access?.map((item) => (
                                                    <div className='footer-link-speeed'>
                                                        {item.type === 1 && <Link to={item.url}>{item.title}</Link>}
                                                    </div>
                                                ))
                                            }

                                        </div>
                                    </Col>
                                    <Col md={2} sm={12}>
                                        <h5 className='title-footer'>دوره ها</h5>
                                        <div className='footer-speed-container'>
                                            {
                                                this.state.courses?.slice(0, 5)?.map((item) => (
                                                    <div className='footer-link-speeed'>
                                                        <Link
                                                            to={`/courses-category/${item.slug}`}> {item.title} </Link>
                                                    </div>
                                                ))
                                            }

                                        </div>
                                    </Col>
                                    <Col md={2} sm={12}>
                                        <h5 className='title-footer'>برچسب ها</h5>
                                        <div className='footer-speed-container'>
                                            {
                                                this.state.tags?.slice(0, 5)?.map((item) => (
                                                    <div className='footer-link-speeed'>
                                                        <Link
                                                            to={`/course-tags/${item.slug}`}> {item.name} </Link>
                                                    </div>
                                                ))
                                            }

                                        </div>
                                    </Col>
                                    <Col md={2} sm={12}>
                                        <h5 className='title-footer'>تماس با ما</h5>

                                        <div className='footer-location'>
                                            <span>آدرس: </span>
                                            {data.address && <p className={"text-justify"}>{data.address}</p>}
                                        </div>

                                        <div className='footer-phone'>
                                            <span>تلفن: </span>
                                            {data.mobile?.map(item => (
                                                <a href={`tel:${item}`}>
                                                    <Phone/> {item}
                                                </a>
                                            ))}
                                        </div>
                                    </Col>
                                    <Col md={3} sm={12}>
                                        <div>
                                            <iframe
                                                className="map-contact"
                                                src={data.ifeameLink}
                                                title="مشاهده «آموزشگاه فنی و حرفه ای کامپیوتر باران» روی نقشه بلد"
                                                width="100%"
                                                height="250"
                                                allowFullScreen="" aria-hidden="false" tabIndex="0"
                                                ></iframe>
                                            <div className='footer-item-nemad mt-1'>
                                                <div className=" nemad-box">
                                                    <a referrerPolicy='origin' target='_blank'
                                                       className=''
                                                       rel={"nofollow"}
                                                       href={data.enamadLink}><img
                                                        referrerPolicy='origin'
                                                        src={data.enamadImageLink}
                                                        alt='' style={{cursor: 'pointer'}} Code={data.enamadCode}/></a>
                                                </div>

                                                <div className=' nemad-box '>
                                                    <a href={"https://www.zarinpal.com/trustPage/baran-academy.ir"}
                                                       target='_blank' rel={"nofollow"}>
                                                        <img src={zarin}/>
                                                    </a>
                                                </div>
                                            </div>

                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                    </div>

                    <div className='border-footer'></div>

                    <div className="copyright p-1 w-100 m-auto">
                        <p className="m-0">
                            {'کلیه حق و حقوق وبسایت برای '}
                            <a href={data.url}>
                                <strong className='text-bold'>
                                    {data.faName}
                                </strong>
                            </a>
                            {' محفوظ است. '}
                        </p>
                        <a href="https://barantm.ir" target='_blank' rel='noopener' className="my-auto">
                            <p className="m-0">
                                {' این وبسایت توسط '}
                                <a href="https://barantm.com">
                                    <strong className='text-bold'>
                                        شرکت برنامه نویسی باران
                                    </strong>
                                </a>
                                {'  طراحی و تولید شده است.'}
                            </p>
                        </a>

                    </div>

                </div>
               <div className="div-contact">
                        <div className={this.state.support ? "hidden-support open" : "hidden-support"}>
                            <div className="title-support">
                                <h2> تماس و پشتیبانی</h2>
                                <hr/>
                                <div className='text-center text-dark'>
                                    <div className='button-support d-flex flex-column align-items-center '>
                                        <div className='phone-btn'>
                                            {data.mobile.map((item) => (
                                                <NavLink
                                                    href={`tel: ${item}`}
                                                    target="_blank" title={item} rel="noopener noreferrer">
                                                    {item}
                                                    <Phone/>
                                                </NavLink>
                                            ))}
                                            <span className="top"></span>
                                            <span className="right"></span>
                                            <span className="bottom"></span>
                                            <span className="left"></span>
                                        </div>
                                        <div className='media-icon'>
                                            <div>
                                                <hr/>
                                                <h2> مارا در شبکات اجتماعی دنبال کنید.</h2>
                                            </div>
                                            <div className='d-flex align-items-center justify-content-center'>
                                                <RenderMedia/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button className="btn-contact" onClick={() => {
                            this.handleSupport()
                        }} title="تماس و پشتیبانی" aria-label="تماس و پشتیبانی">
                            {this.state.support ?
                                <Close/>
                                :
                                <BiSupport/>
                            }
                        </button>
                    </div>
                <div className="copyright copyright-phone p-1 w-100 m-auto">
                    <p className="m-0">
                        کلیه حق و حقوق وبسایت برای {data.faName} محفوظ است
                    </p>
                </div>

            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        UI: state.UI
    }
}

export default connect(mapStateToProps)(Footer);
